@import "../../../../shared/scss/index";

:host {
  display: block;

  .limit-stretch {
    @include limit-stretch();
  }

  .main-content {
    inline-size: 20px;

    &:focus {
      outline-style: none;
    }
  }

  .screenreader-only {
    position: absolute;
    inline-size: 1px;
    block-size: 1px;
    white-space: nowrap;
    overflow: hidden;
    clip: rect(1px, 1px, 1px, 1px);
    clip-path: inset(50%);
  }

  &:has(phn-country-recommender) .hide-show-on-scroll.hide {
    transform: translateY(calc(-100% - var(--country-height, 0px)));
  }
}
